<nha-dialog width="extra-wide" titleIcon="notifications" nhaTest="notification-settings-dialog">
	<div dialog-title>Notification Settings</div>

	<div dialog-content class="notification-settings-content">
		<div class="settings-toolbar">
			<nha-search-box
				placeholder="Search notification types"
				[lockOpen]="true"
				[gray]="true"
				[boxShadow]="false"
				(changed)="searchText.set($event)"
			></nha-search-box>

			<div class="save-status-area" aria-live="polite">
				@if (saveStatus()) {
					<nha-save-status [saveStatus]="saveStatus()"></nha-save-status>
				}
			</div>
		</div>

		@if (isLoading()) {
			@for (row of [1, 2, 3]; track row) {
				<div class="settings-skeleton-row">
					<nha-skeleton width="32px" height="32px" radius="6px"></nha-skeleton>
					<div class="settings-skeleton-text">
						<nha-skeleton width="180px" height="14px" radius="4px"></nha-skeleton>
						<nha-skeleton width="110px" height="12px" radius="4px"></nha-skeleton>
					</div>
				</div>
			}
		} @else if (hasError()) {
			<div class="settings-error">
				<nha-alert-box type="error" message="Couldn't load notification settings."></nha-alert-box>
				<button type="button" class="retry-link" (click)="load()" nhaTest="notification-settings-retry">Try again</button>
			</div>
		} @else {
			@for (app of filteredPreferences(); track app.app.businessApplicationID) {
				<div class="app-section" nhaTest="notification-app-section">
					<button
						type="button"
						class="section-header"
						(click)="toggleSection(app.app.businessApplicationID)"
						[attr.aria-expanded]="isExpanded(app.app.businessApplicationID)"
					>
						<span class="app-square" [style.background-color]="app.app.color" aria-hidden="true">
							{{ app.app.appName?.charAt(0) }}
						</span>
						<span class="section-title">
							<span class="app-name">{{ app.app.appName }}</span>
							<span class="section-summary">{{ summary(app) }}</span>
						</span>
						<mat-icon class="section-chevron">{{ isExpanded(app.app.businessApplicationID) ? 'expand_less' : 'expand_more' }}</mat-icon>
					</button>

					@if (isExpanded(app.app.businessApplicationID)) {
						<div class="section-body">
							<div class="type-grid type-grid-header">
								<span>Notification type</span>
								<span class="col-center">On/Off</span>
								<span class="col-center">In-App</span>
								<span class="col-center">Email</span>
								<span>Frequency</span>
							</div>

							@for (type of app.types; track type.notificationTypeID) {
								<div class="type-grid type-row" [class.muted]="!type.enabled" nhaTest="notification-type-row">
									<div class="type-info">
										<div class="type-name">{{ type.name }}</div>
										<div class="type-description">{{ type.description }}</div>
									</div>
									<div class="col-center">
										<mat-slide-toggle
											[checked]="type.enabled"
											(change)="updateType(app.app.businessApplicationID, type.notificationTypeID, { enabled: $event.checked })"
											[aria-label]="type.name + ' on/off'"
										></mat-slide-toggle>
									</div>
									<div class="col-center">
										<mat-checkbox
											[checked]="type.inApp"
											[disabled]="!type.enabled"
											(change)="updateType(app.app.businessApplicationID, type.notificationTypeID, { inApp: $event.checked })"
											[aria-label]="type.name + ' in-app'"
										></mat-checkbox>
									</div>
									<div class="col-center">
										<mat-checkbox
											[checked]="type.email"
											[disabled]="!type.enabled"
											(change)="updateType(app.app.businessApplicationID, type.notificationTypeID, { email: $event.checked })"
											[aria-label]="type.name + ' email'"
										></mat-checkbox>
									</div>
									<div class="frequency-cell">
										@if (type.canOverrideFrequency) {
											<mat-form-field class="frequency-field" subscriptSizing="dynamic">
												<mat-select
													[value]="type.notificationFrequencyID"
													[disabled]="!type.enabled"
													(selectionChange)="
														updateType(app.app.businessApplicationID, type.notificationTypeID, {
															notificationFrequencyID: $event.value
														})
													"
													[aria-label]="type.name + ' frequency'"
												>
													@for (frequency of frequencies(); track frequency.notificationFrequencyID) {
														<mat-option [value]="frequency.notificationFrequencyID">{{ frequency.frequencyName }}</mat-option>
													}
												</mat-select>
											</mat-form-field>
										} @else {
											<span class="frequency-fixed">{{ frequencyName(type.notificationFrequencyID) }}</span>
										}
									</div>
								</div>
							}
						</div>
					}
				</div>
			} @empty {
				<nha-no-data-message message="No notification types match your search."></nha-no-data-message>
			}
		}
	</div>

	<div dialog-footer>
		<button mat-flat-button color="primary" (click)="done()" nhaTest="notification-settings-done">Done</button>
	</div>
</nha-dialog>
